import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { CssBaseline, ThemeProvider, createTheme } from '@mui/material';
import { QueryProvider } from './providers/QueryProvider';
import { PlatformAuthProvider } from './contexts/PlatformAuthContext';
import App from './App.jsx';
import './i18n';
import './index.css';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: { main: '#5c9fd4' },
    background: { default: '#0f1419', paper: '#1a222d' },
  },
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <QueryProvider>
        <BrowserRouter>
          <PlatformAuthProvider>
            <App />
          </PlatformAuthProvider>
        </BrowserRouter>
      </QueryProvider>
    </ThemeProvider>
  </StrictMode>,
);
